import React from 'react';
import proptypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';

const { string, element, arrayOf } = proptypes;

export const Tip = ({ text = '', texts = [], children = null }) => {
  return (
    <div className="sui-p-4">
      <Typography component="span" weight="bold" height="tight">
        Tip:
      </Typography>
      {!!text && (
        <Typography key={text} component="span" weight="regular" height="tight">
          &nbsp;{'\u00A0'}{text}
          {!!texts?.length && <><br /><br /></>}
        </Typography>
      )}
      {!!texts?.length && (
        texts.map((textItem, index) => (
          <Typography key={textItem} component="span" weight="regular" height="tight">
            {index === 0 && <>&nbsp;</>}
            {'\u00A0'}{textItem}
            {index < texts?.length - 1 && <><br /><br /></>}
          </Typography>
        ))
      )}
      {children}
    </div>
  );
};

Tip.propTypes = {
  text: string,
  texts: arrayOf(string),
  children: element
};
